import { ConfirmationSelectIncident } from './ConfirmationSelectIncident';
import { ConfirmationIncident } from './ConfirmationIncident';
import { SuccessReport } from './SuccessReport';
import { popupIncidentType } from '../utils/incidentPopupUtil';

export const popupStateMetadata = {
  [popupIncidentType.CONFIRMATION_SELECT_INCIDENT]: ConfirmationSelectIncident,
  [popupIncidentType.CONFIRMATION_INCIDENT]: ConfirmationIncident,
  [popupIncidentType.SUCCESS_REPORT]: SuccessReport,
};
